// extracted by mini-css-extract-plugin
export default {"ResultSetSlider":"ResultSetSlider_ResultSetSlider__XU47P"};